import { FC, useState, useEffect } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import {
  useRolesSelector,
  RolesActions,
  useRolesDispatch,
} from '@wajeez-web/stores/roles';
import { SuperAdminSystemPermissions } from '@wajeez-web/core/types';
import { WajeezList, WajeezRow } from '@wajeez-web/components/list-builder';
import { Button, TextInput } from '@wajeez-web/components/ui';
import { useTranslation } from 'react-i18next';
import { Identity } from '@wajeez-web/core/api-base';
import { BiAddToQueue } from 'react-icons/bi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { PlusCircleIcon } from '@heroicons/react/solid';
import RoleClaimsModal from '../components/RoleClaimsModal';

const RolesAndPermisionsPage = () => {
  const { data, status, details } = useRolesSelector((state) => state.roles);
  const dispatch = useRolesDispatch();
  const [newRole, setNewRole] = useState('');

  const [assignModalState, setAssignModalstate] = useState(false);
  const { t } = useTranslation();

  const onDelete = async (id: string) => {
    const res = await dispatch(RolesActions.deletRolebyIdAsync(id));

    if (res.meta.requestStatus === 'fulfilled') {
      getData();
    }
  };
  const addItem = async () => {
    const res = await dispatch(RolesActions.addNewRoleAsync({ name: newRole }));
    if (res.meta.requestStatus === 'fulfilled') {
      setNewRole('');
      getData();
    }
  };

  const getData = () => {
    setNewRole('');
    dispatch(RolesActions.getAllRolesAsync());
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="h-full">
      {assignModalState && (
        <RoleClaimsModal
          data={details || undefined}
          isOpen={assignModalState}
          onClose={() => {
            setAssignModalstate(false);
          }}
          onSubmit={async (data) => {
            if (data) {
              const res = await dispatch(
                RolesActions.updateRolePermissionsAsync(data)
              );
              if (res.meta.requestStatus === 'fulfilled') {
                setAssignModalstate(false);
                getData();
              }
            }
          }}
        />
      )}
      <PageLayoutsContainer
        title="Roles And Permissions"
        withoutRightPadding={true}
        breadCrumbsLinks={[{ title: 'Roles-And-Permissions' }]}
      >
        <div className="space-y-4">
          <TextInput
            value={newRole}
            onChange={(name, val) => setNewRole(val)}
            name="newrole"
            suffix={
              <Button
                color="primary"
                onClick={() => addItem()}
                type="text"
                Icon={PlusCircleIcon}
              />
            }
          />
          <WajeezList
            isLoading={status === 'loading'}
            keyExtractor={(item) => item.id as string}
            data={data}
            containerType="rows"
            renderItem={(item, i) => (
              <WajeezRow
                key={i}
                title={item.name}
                endSideComponents={[
                  <Button
                    shape="circle"
                    color="red-500"
                    bg="gray-100"
                    key={i + 'delete'}
                    onClick={() => onDelete(item.id as string)}
                    Icon={RiDeleteBinLine}
                    type="text"
                  />,

                  <Button
                    shape="circle"
                    color="primary"
                    bg="gray-100"
                    key={i + 'assign'}
                    onClick={() => {
                      dispatch(
                        RolesActions.getRolePermissionsAsync(item.id || '')
                      ).then((res) => {
                        if (res.meta.requestStatus === 'fulfilled') {
                          setAssignModalstate(true);
                        }
                      });
                    }}
                    Icon={BiAddToQueue}
                    type="text"
                  />,
                ]}
              />
            )}
          />
        </div>
      </PageLayoutsContainer>
    </div>
  );
};

export default RolesAndPermisionsPage;
